// extracted by mini-css-extract-plugin
export default {"dragOverlayItem":"BoardTree_dragOverlayItem__8KNei"};